'use client';

import type { ReactNode } from 'react';
import useStyles from './styles';

type WithChildren = { children: ReactNode };

const HeaderSkeleton = ({ children }: WithChildren) => {
  const classes = useStyles();
  return <section className={classes.headerSkeleton}>{children}</section>;
};

export const GridSection = ({ children }: WithChildren) => {
  const classes = useStyles();
  return <section className={classes.gridSection}>{children}</section>;
};

export const PresetHeroSkeleton = ({ children }: WithChildren) => {
  const classes = useStyles();
  return <div className={classes.presetHero}>{children}</div>;
};

export const PresetSimilarSkeleton = ({ children }: WithChildren) => {
  const classes = useStyles();
  return <div className={classes.presetSimilar}>{children}</div>;
};

export default HeaderSkeleton;
